
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { projects } from '../../../mocks/projectData';

export default function Portfolio() {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  const [visibleProjects, setVisibleProjects] = useState(projects);
  const navigate = useNavigate();

  useEffect(() => {
    let deletedIds: string[] = [];
    let uploadedImages: any[] = [];

    try {
      const deletedRaw = localStorage.getItem('deletedImages');
      deletedIds = deletedRaw ? JSON.parse(deletedRaw) : [];
    } catch (e) {
      console.error('Failed to parse deletedImages from localStorage', e);
    }

    try {
      const uploadedRaw = localStorage.getItem('uploadedImages');
      uploadedImages = uploadedRaw ? JSON.parse(uploadedRaw) : [];
    } catch (e) {
      console.error('Failed to parse uploadedImages from localStorage', e);
    }

    const filteredProjects = projects.filter(
      (project) => !deletedIds.includes(project.image)
    );

    const uploadedProjects = uploadedImages
      .filter((img) => img.category === 'projects')
      .map((img, idx) => ({
        name: `업로드된 프로젝트 ${idx + 1}`,
        location: '서울',
        year: new Date().getFullYear().toString(),
        size: '신규',
        image: img.url,
        slug: `uploaded-${idx}`,
      }));

    setVisibleProjects([...filteredProjects, ...uploadedProjects]);
  }, []);

  const handleProjectClick = (slug: string) => {
    navigate(`/project/${slug}`);
  };

  return (
    <section id="portfolio" className="py-16 sm:py-20 lg:py-32 bg-stone-50">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-12">
        <div className="flex items-end justify-between mb-10 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900">
            주요 프로젝트
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5">
          {visibleProjects.map((project, index) => (
            <div
              key={project.slug || index}
              className="relative group cursor-pointer overflow-hidden rounded-xl"
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
              onClick={() => handleProjectClick(project.slug)}
              style={{
                transform: hoveredIndex === index ? 'scale(1.02)' : 'scale(1)',
                transition: 'transform 0.3s ease',
              }}
            >
              <div className="relative w-full h-64 sm:h-80 lg:h-96">
                <img
                  src={project.image}
                  alt={project.name}
                  className="w-full h-full object-cover"
                />
              </div>

              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />

              <div className="absolute top-3 right-3 sm:top-4 sm:right-4">
                <span className="px-2.5 py-1 sm:px-3 bg-white/90 text-gray-900 text-xs font-medium rounded-full whitespace-nowrap">
                  {project.size}
                </span>
              </div>

              <div className="absolute bottom-0 left-0 right-0 p-4 sm:p-6">
                <h3 className="text-lg sm:text-xl font-bold text-white mb-1 sm:mb-2">
                  {project.name}
                </h3>
                <p className="text-xs sm:text-sm text-gray-300">
                  {project.location} • {project.year}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
